import "./checkpointStore.js";

export type LocalCheckpoint<T = unknown> = {
  key: string;
  scope: string;
  sequence: number;
  payload: T;
  updatedAt?: number;
  savedSequence?: number;
  serverSessionId?: string | null;
  serverCheckpointId?: string;
};

declare global {
  var CeliaCheckpointStore: {
    get<T>(key: string): Promise<LocalCheckpoint<T> | null>;
    save<T>(entry: LocalCheckpoint<T>): Promise<LocalCheckpoint<T>>;
    acknowledge<T>(key: string, sequence: number, metadata?: Record<string, unknown>): Promise<LocalCheckpoint<T> | null>;
    list<T>(scope: string, limit?: number): Promise<LocalCheckpoint<T>[]>;
    pending<T>(actor: string, limit?: number): Promise<LocalCheckpoint<T>[]>;
    remove(key: string): Promise<boolean>;
  };
}

export const checkpoints = globalThis.CeliaCheckpointStore;
